import React from 'react';

import Filters from '../Interest/General/Filters';
import { DateRangeFilter, LabelMultiSelectFilter, SubmitFilter } from '../Interest/Filters';
import Content from '../Interest/General/Content';
import NewsTable from './Tables/NewsTable';

import { Filter } from '../../Enum/Filters';
import { MAX_AMOUNT_SELECTED, NEWS_FILTER } from '../../Constants/Interest/Filter';

import useGetFilterValue from '../../Hook/Interest/UseGetFilterValue';

const News: React.FC = () => {
    const selectedLabels = useGetFilterValue(Filter.NewsLabels) as string[];

    return (
        <div className="interest-content-wrapper" data-testid="properties-change-per-label">
            <Filters filterTotals={{
                amountSelected: selectedLabels.length,
                maxAmountSelected: MAX_AMOUNT_SELECTED
            }}>
                <SubmitFilter filterProperties={NEWS_FILTER} allowEmptyArray />
                <hr />
                <LabelMultiSelectFilter
                    label="Filter op product"
                    placeholder="Productnaam"
                    filterType={Filter.NewsLabels}
                    showExistingCustomers={true}
                    maxAmountSelectedLabels={MAX_AMOUNT_SELECTED}
                    setFilter
                />
                <hr />
                <DateRangeFilter />
            </Filters>
            <Content>
                <NewsTable />
            </Content>
        </div>
    );
}

export default News;
